import React, {createRef, PureComponent} from "react";
import Select from "react-select";
import configuration from "../../configuration/carousels.json";
import "./SearchBar.scss";
import {window} from "react-popover/source/platform";
import ConfigurationHelper from "../../configuration/ClientConfigurationHelper";

const options = [
    {value: 'all', label: 'All Videos'},
    {value: configuration.howToAndProject, label: "How To's Video"},
    {value: 'all', label: 'Product Videos'}
];

const customStyle = {
    control: styles => ({
        ...styles,
        backgroundColor: '#2E4787',
        color: '#ffffff',
        borderTopLeftRadius: "25px",
        borderBottomLeftRadius: "25px",
        borderRight: 0,
        outline: 'none',
        minHeight: '34px',
        height: '34px',
        alignContent: 'center',
        ':hover': {
            borderColor: 'transparent',
            boxShadow: 'none'
        }
    }),
    menu: (styles, state) => ({
        ...styles,
        width: '205px',
        color: '#333333'
    }),
    option: (styles, state) => ({
        ...styles,
        color: '#333333',
        fontFamily: "Roboto, sans-serif",
        backgroundColor: state.isSelected ? `#F5F5F5` : '#ffffff'
    }),
    singleValue: (styles, state) => ({
        ...styles,
        color: '#ffffff',
        fontFamily: "Roboto, sans-serif",
        fontSize: '14px',
        fontWeight: '700',
        lineHeight: '21px',
        textAlign: 'left',
    })

};

class SearchBar extends PureComponent {
    constructor(props) {
        super(props);
        this.input = createRef();
    }

    onKeyPress = (e) => {
        if(e.keyCode === 13)
            this.goToSearchPage()
    }

    goToSearchPage = () => {
        const searchTerm = this.input.current.value;
        window.location.href = ConfigurationHelper.getGlobalConfiguration().sub_folder + `/search/?s=${searchTerm}`;

    }

    render() {

        return <div className={"search-container"}>
            <div className={"search-input"}>
                <input ref={this.input} onKeyDown={this.onKeyPress} placeholder={this.props.placeholder} type="text"/>
                <button onClick={this.goToSearchPage}>
                    { this.props.arrow ? <svg width="24px" height="24px" viewBox="0 0 24 24">
                            <path fill="#5a5a5a" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                        </svg>
                        : <svg fill="#000000" width="19" height="20" viewBox="0 0 1792 1792"
                         xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M1216 832q0-185-131.5-316.5T768 384 451.5 515.5 320 832t131.5 316.5T768 1280t316.5-131.5T1216 832zm512 832q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225T64 832t55.5-273.5 150-225 225-150T768 128t273.5 55.5 225 150 150 225T1472 832q0 220-124 399l343 343q37 37 37 90z">
                        </path>
                    </svg>}
                </button>
            </div>
        </div>

    }
}
SearchBar.defaultProps = {
    placeholder: "Search Videos",
    arrow: false
};

export default SearchBar;